import { UntypedFormArray } from '@angular/forms';

export function RequiredTrueArrayValidator(formArray: UntypedFormArray) {
  if (!formArray || formArray.value.every((c: Boolean) => !c)) {
    return { required: true };
  }

  return null;
}
